import _get from 'lodash/get';
import { layoutService, LAYOUT_ENTITIES, LAYOUT_FRONTSPACES } from '@bedrock/fido-sdk';
import { errorAction } from '../error/error.actions';
import { ERROR_LEVELS, ERROR_TYPES } from '../error/error.constants';
import { SCREEN_SAVER_DATA, SCREEN_SAVER_IS_LOCKED } from './screenSaver.constants';
import { getScreenSaverData } from './screenSaver.selectors';
import { getScreensaverFeature } from '../features/features.selectors';

export const fetchScreenSaverData =
  (sectionCode = 'main') =>
  async (dispatch, getState) => {
    const state = getState();

    if (_get(getScreenSaverData(state), 'section') === sectionCode || !getScreensaverFeature(state)) {
      return;
    }

    const entity = {
      entityType: LAYOUT_ENTITIES.frontspace,
      entityId: LAYOUT_FRONTSPACES.screensaver,
      sectionCode,
    };
    let data = null;
    try {
      data = await layoutService.fetchByEntity(entity);
    } catch (error) {
      dispatch(errorAction(ERROR_LEVELS.SILENT, ERROR_TYPES.GENERAL, 'Screen Saver fetching error'));
    }

    dispatch({ type: SCREEN_SAVER_DATA, data });
  };

export const setScreenSaverIsLocked = isLocked => ({
  type: SCREEN_SAVER_IS_LOCKED,
  data: { isLocked },
});
